enum ActionType {
  updateParameter = 'UPDATE_PARAMETER',
  verifyIdentification = 'VERIFY_IDENTIFICATION',
  successToVerifyIdentification = 'SUCCESS_TO_VERIFY_IDENTIFICATION',
  failedToVerifyIdentification = 'FAILED_TO_VERIFY_IDENTIFICATION'
}

export const ALREADY_APPLIED_CODE = 'sumamoru-application-already-applied';

export type verifyIdentificationErrorStatus =
  | 'no_error'
  | 'invalid_request'
  | 'unauthorized'
  | 'locked'
  | 'already_applied'
  | 'canceled'
  | 'internal';

export interface IdentificationParameterState {
  birthday: string;
}

export default ActionType;
